import initCarousel from '../helpers/carousel';

export default class MainCollectionBanner {
  constructor(section) {
    this.el = section.el;
    this.splide = null;

    const mountRoot = this.el.querySelector(
      '[data-plp-visual-filter-carousel]',
    );
    if (!mountRoot?.querySelector('[data-splide-carousel]')) {
      return;
    }

    const vsFilters = [...this.el.querySelectorAll('[data-visual-filter]')];

    this.syncActiveClass = () => {
      vsFilters.forEach(filter => {
        filter.classList.toggle(
          'vf-is-active',
          filter.href === window.location.href,
        );
      });
    };

    this.syncActiveClass();
    document.addEventListener('ss:filters:change', this.syncActiveClass);

    vsFilters.forEach(vsFilter => {
      vsFilter.addEventListener('click', () => {
        vsFilters.forEach(filter => {
          filter.classList.toggle('vf-is-active', filter === vsFilter);
        });
      });
    });

    const active = vsFilters.find(f => f.classList.contains('vf-is-active'));
    const activeIndex = active ? parseInt(active.dataset.index, 10) || 0 : 0;
    const start = Math.max(0, activeIndex - 1);

    this.splide = initCarousel(
      mountRoot,
      {
        type: 'slide',
        autoWidth: true,
        gap: '0.75rem',
        drag: 'free',
        arrows: true,
        pagination: false,
        start,
      },
      true,
    );
  }

  onSectionUnload() {
    if (this.syncActiveClass) {
      document.removeEventListener('ss:filters:change', this.syncActiveClass);
      this.syncActiveClass = null;
    }
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
